export default "__VITE_ASSET__DoVQGRTP__"